import { Heading } from 'components/Heading'
import GithubSlugger from 'github-slugger'
import React from 'react'
import { prepareData } from 'utils/googleData'

const responsive = (divider) => ({
    wrapper: {
        1: '',
        2: `grid-cols-1 sm:grid-cols-2 ${divider ? 'sm:divide-x' : ''}`,
        3: `grid-cols-1 md:grid-cols-3 ${divider ? 'md:divide-x' : ''}`,
        5: `grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 ${divider ? 'lg:divide-x' : ''}`,
        4: `grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 ${divider ? 'lg:divide-x' : ''}`,
        6: `grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${divider ? 'lg:divide-x' : ''}`,
        7: `grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${divider ? 'lg:divide-x' : ''}`,
        8: `grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${divider ? 'lg:divide-x' : ''}`,
    },
})

const headingSize = {
    sm: 'text-2xl md:text-[30px]',
    md: 'text-3xl md:text-[48px]',
    lg: 'text-4xl md:text-[64px]',
}

const contentSize = {
    full: 'w-full',
    sm: 'max-w-[600px]',
    md: 'max-w-[800px]',
    lg: 'max-w-[1200px]',
}

export function Section(props) {
    const {
        enable,
        title,
        name,
        description,
        cta,
        direction,
        style,
        gatsbyImage,
        gatsbyImage2,
        gatsbyImage3,
        text,
        gatsbyImageSrc,
        features,
        children,
        cols,
        titleSize = 'sm',
        className = '',
        size = 'full',
        divider = true,
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const slugger = new GithubSlugger()
    const id = slugger.slug(title)
    let childCreated
    const colsInput = cols || features?.length || 1
    if (Array.isArray(features) && features.length > 0) {
        childCreated = features.map(({ title, subtitle, description }, index) => {
            const isLastItem = index === features.length - 1 && features.length % 3 === 1
            return (
                <div key={index} className={`${isLastItem ? 'col-span-1 col-start-2' : ''} `}>
                    <h5>
                        <span className="block text-2xl text-red">{title}</span> {subtitle}
                    </h5>
                    <p>{description}</p>
                </div>
            )
        })
    }
    return (
        <section style={style} className={`my-10 sm:mt-12 sm:mb-20 ${className}`}>
            {title && (
                <Heading id={id} hideCopy as="h2" className={`mb-16 text-center ${headingSize[titleSize]}`}>
                    {title}
                </Heading>
            )}
            <div
                className={`grid ${
                    divider ? 'divide-dashed divide-gray-accent-light' : ''
                } template-section-content mx-auto ${responsive(divider).wrapper[colsInput]} ${contentSize[size]}`}
            >
                {childCreated}
                {children}
            </div>
        </section>
    )
}
export default Section
